import { Examples } from '@/types';

export const ExampleMStoreMakeChangesLockRoutes =
  process.env.NODE_ENV !== 'production'
    ? [
      {
        ...Examples.ExampleMStoreMakeChangesLock,
        components: {
          default: () => import(/* webpackChunkName: "ExampleMStoreMakeChangesLock" */ 
          '@/views/examples/ExampleMStoreMakeChangesLock.vue')
        }
      }
    ]
    : [];